export const VIEWING_PROFILE_HEADER_INFO_ITEMS_LOADING_LENGTH = 3

export const QA_NAME_VIEWING_PROFILE_INFO_APPLICANT =
  'viewingProfileInfoApplicant'

export const QA_NAME_VIEWING_PROFILE_INFO_MANAGER = 'viewingProfileInfoManager'

export const QA_NAME_VIEWING_PROFILE_INFO_TIME = 'viewingProfileInfoTime'
